import { TITLE_COMPONENT_SEPARATOR } from '../components/AutoPageTitle';

export async function copyTextToClipboard(text: string) {
  if (!('clipboard' in navigator)) {
    document.execCommand('copy', true, text);
    return;
  }

  await navigator.clipboard.writeText(text);
}

export async function copyCurrentLocation() {
  const title = document.title?.split(TITLE_COMPONENT_SEPARATOR)?.[0]?.trim();

  const url = window.location.href;

  if (!('navigator' in window)) {
    document.execCommand('copy', true, url);
    return;
  }

  await window.navigator.clipboard.write([
    new ClipboardItem({
      'text/plain': url,
      'text/html': `<a href="${url}">${title}</a>`,
    }),
  ]);
}
